export default __webpack_public_path__ + "static/media/store-logo-etsy-overlay.803a235e.png";